"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense, useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
interface NavigationObserverProps {
  /** Called once per distinct pathname + query string, including the first render. */
  onNavigate: () => void;
}
function NavigationObserverContent(t0) {
  const $ = _c(6);
  const {
    onNavigate
  } = t0;
  const pathname = usePathname();
  const search = useSearchParams()?.toString() ?? "";
  const onNavigateRef = useRef(onNavigate);
  let t1;
  if ($[0] !== onNavigate) {
    t1 = () => {
      onNavigateRef.current = onNavigate;
    };
    $[0] = onNavigate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEffect(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      onNavigateRef.current();
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== pathname || $[4] !== search) {
    t3 = [pathname, search];
    $[3] = pathname;
    $[4] = search;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  return null;
}

/**
 * Reports client-side navigations, including query-string-only changes
 * (filters, pagination, search) that `usePathname` alone cannot see.
 *
 * `useSearchParams` needs a Suspense boundary or it opts the whole page out of
 * static rendering, so the hook lives in a boundary of its own.
 */
export function NavigationObserver(t0) {
  const $ = _c(2);
  const {
    onNavigate
  } = t0;
  let t1;
  if ($[0] !== onNavigate) {
    t1 = <Suspense fallback={null}><NavigationObserverContent onNavigate={onNavigate} /></Suspense>;
    $[0] = onNavigate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}